import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppWithAssignment, MarketplaceApp, MarketplaceStore } from '@realwear-cloud/app-marketplace/shared';
import { BaseComponent } from '@realwear-cloud/shared/ui-kit';
import { Observable, filter, map, of, takeUntil } from 'rxjs';

@Component({
  selector: 'realwear-cloud-marketplace-home',
  templateUrl: './marketplace-home.component.html',
  styleUrls: ['./marketplace-home.component.scss']
})
export class MarketplaceHomePageComponent extends BaseComponent implements OnInit {
  category = 'featured';
  searchResultsApps$: Observable<MarketplaceApp[] | AppWithAssignment[]> = of([]);

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private store: MarketplaceStore) {
    super();
  }

  async ngOnInit() {
    this.activatedRoute.paramMap
      .pipe(
        map((j) => j.get('category')),
        takeUntil(this.destroyed$)
      )
      .subscribe((category) => (this.category = category || ''));

    this.store
      .select((state) => state.appDetailRequested)
      .pipe(
        filter((appId) => !!appId),
        takeUntil(this.destroyed$)
      )
      .subscribe(async (appId) => {
        this.store.updateState({ appDetailRequested: '' });
        await this.router.navigateByUrl('/app/' + appId);
      });
  }
}
